export default {
    /**
    * 修改公共时间
    * */
    changeTime ({ commit }, reqTime) {
        commit("CHANGE_TIME", reqTime)
    },
    /**
    * 修改数据跟新时间
    * */
    changeRealTime ({ commit }, reqTime) {
        commit("CHANGE_REALTIME", reqTime)
    },
    /**
     * 修改公共月数
     * */
    changeMonth ({ commit }, reqMonth) {
        commit("CHANGE_MONTH", reqMonth)
    },
    /***
     * 修改公共城市
     * */
    changeCity ({ commit }, reqCity) {
        commit("CHANGE_CITY", reqCity)
    },
    /**
     *  修改动画加载状态和第几个页面
     * @param {*} param
     * @param {*} infor 传入导航信息
     */
    changeLoading ({ commit }, infor) {
        commit('CHANGE_LOADING', infor)
    },
    changeNavigation ({ commit }, name) {
        commit('CHANGE_NAVIGATION', name)
    }
}